import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_POST_METHOD, API_GET_METHOD } from 'global_config/constant-global';

export async function fetchCheckInSpecimen(payload) {
	try{
		const content = {
			method: API_POST_METHOD,
			url: `specimentracking/checkinspecimen`,
			data: {
				p_sample_id: payload.sampleSpecimenID,
				p_login_user_id: payload.userID,
				p_specimen_location: payload.checkinLocation
			}
		}

		console.log('Check-in request payload:', content);
		console.log('Sample ID being sent:', payload.sampleSpecimenID);
		console.log('Login User ID:', payload.userID);
		console.log('Specimen Location:', payload.checkinLocation);

		const response = await axiosLabAPI(content);
		const { data } = await response;

		console.log('Check-in response:', data);

		// Check if response contains RECORDS
		if (data && data.RECORDS && Array.isArray(data.RECORDS) && data.RECORDS.length > 0) {
			return data.RECORDS.at(0) || [];
		}
		
		return [];
	}
	catch(error) {
		console.log('Check-in error:', error);
		console.log('Check-in error response:', error.response);
        if(error.response && error.response.data) {
			// Check for MESSAGE (uppercase) or message (lowercase) or error
			const errorMessage = error.response.data.MESSAGE || error.response.data.message || error.response.data.error || 'An error occurred';
			console.log('Error message:', errorMessage);
			Message.error(errorMessage);
		}
		else { 
			Message.error('Failed to check in specimen'); 
		}
		return false;
	}
}

export async function fetchActiveLabLocations() {
	try{
		const content = {
			method: API_GET_METHOD,
			url: `settings/lablocationactive`
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data.RECORDS || [];
	}
	catch(error) {
        if(error.response && error.response.status === 400) {
			Message.error(error.response.data.error);
		}
		else { 
			Message.error(); 
		}
		return false;
	}
}

export async function fetchCurrentLocation(userID) {
	try{
		const content = {
			method: API_GET_METHOD,
			url: `user/lastcheckinlocation`,
			params: { p_user_id: userID }
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch(error) {
		console.log('error', error);
        if(error.response && error.response.status === 400) {
			Message.error(error.response.data.error);
		}
		else { 
			Message.error(); 
		}
		return false;
	}
}